/**
 * The URL vocabulary for the drawer's panels. A leaf module: the drawer reports
 * its state here and the router reads it, so neither has to import the other.
 *
 *   #/e/FRA        a country or supranational entity, keyed by ISO 3166-1 alpha-3
 *   #/region/MENA  a regional profile
 *   #/methodology  how the atlas is built
 */

/** The hash a given drawer state should be reachable at, or '' for no link. */
export function hashFor(view) {
  if (!view) return '';
  if (view.mode === 'country') return `#/e/${view.c.iso}`;
  if (view.mode === 'region') return `#/region/${encodeURIComponent(view.r)}`;
  if (view.mode === 'method') return '#/methodology';
  return '';   // dimension detail and discovery carry state that a link would not restore honestly
}

/** Reflect the current panel in the address bar without adding history noise. */
export function syncHash(view) {
  const next = hashFor(view);
  if (next === location.hash || (!next && !location.hash)) return;
  history.replaceState(null, '', next || location.pathname + location.search);
}


